module.exports = __webpack_public_path__ + "img/256.b9d568ed.jpg";